import * as TypeGraphQL from "type-graphql";
export var ABTestScalarFieldEnum;
(function (ABTestScalarFieldEnum) {
    ABTestScalarFieldEnum["id"] = "id";
    ABTestScalarFieldEnum["name"] = "name";
    ABTestScalarFieldEnum["description"] = "description";
    ABTestScalarFieldEnum["status"] = "status";
    ABTestScalarFieldEnum["modelVersionAId"] = "modelVersionAId";
    ABTestScalarFieldEnum["modelVersionBId"] = "modelVersionBId";
    ABTestScalarFieldEnum["trafficSplitControlPercent"] = "trafficSplitControlPercent";
    ABTestScalarFieldEnum["trafficSplitTreatmentPercent"] = "trafficSplitTreatmentPercent";
    ABTestScalarFieldEnum["targetMetrics"] = "targetMetrics";
    ABTestScalarFieldEnum["successCriteriaPrimaryMetric"] = "successCriteriaPrimaryMetric";
    ABTestScalarFieldEnum["successCriteriaMinimumDetectableEffect"] = "successCriteriaMinimumDetectableEffect";
    ABTestScalarFieldEnum["successCriteriaSignificanceLevel"] = "successCriteriaSignificanceLevel";
    ABTestScalarFieldEnum["successCriteriaPowerLevel"] = "successCriteriaPowerLevel";
    ABTestScalarFieldEnum["startDate"] = "startDate";
    ABTestScalarFieldEnum["endDate"] = "endDate";
    ABTestScalarFieldEnum["plannedDuration"] = "plannedDuration";
    ABTestScalarFieldEnum["resultsControlMetrics"] = "resultsControlMetrics";
    ABTestScalarFieldEnum["resultsTreatmentMetrics"] = "resultsTreatmentMetrics";
    ABTestScalarFieldEnum["resultsStatisticalSignificance"] = "resultsStatisticalSignificance";
    ABTestScalarFieldEnum["resultsPValues"] = "resultsPValues";
    ABTestScalarFieldEnum["resultsConfidenceIntervals"] = "resultsConfidenceIntervals";
    ABTestScalarFieldEnum["resultsRecommendation"] = "resultsRecommendation";
    ABTestScalarFieldEnum["metadataEnvironment"] = "metadataEnvironment";
    ABTestScalarFieldEnum["metadataEligibilityCriteria"] = "metadataEligibilityCriteria";
    ABTestScalarFieldEnum["metadataExclusionCriteria"] = "metadataExclusionCriteria";
    ABTestScalarFieldEnum["metadataSegmentationRules"] = "metadataSegmentationRules";
    ABTestScalarFieldEnum["createdAt"] = "createdAt";
    ABTestScalarFieldEnum["updatedAt"] = "updatedAt";
    ABTestScalarFieldEnum["completedAt"] = "completedAt";
})(ABTestScalarFieldEnum || (ABTestScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ABTestScalarFieldEnum, {
    name: "ABTestScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ABTestScalarFieldEnum.js.map